const Background = () => {
  return <img src="/assets/Background.jpg" alt="Background" className="w-full h-fit absolute top-0 left-0 right-0" />
}

export default Background
